import { Heading, Link, Paragraph } from '@buffer-mono/popcorn'

import type { ErrorFallbackProps } from './types'

import styles from './ErrorBoundary.module.css'

import type { JSX } from 'react'

const openBrainFishWidget = (): void => {
  if (window.Brainfish?.Widgets?.open) {
    window.Brainfish.Widgets.open()
  } else {
    window.open('https://support.buffer.com/?openContact=true', '_blank')
  }
}

const FittedFallbackComponent = (_props: ErrorFallbackProps): JSX.Element => {
  return (
    <div className={styles.errorBoundaryFit}>
      <Heading as="h2" size="large">
        Well this is embarrassing...
      </Heading>
      <Paragraph
        size="lg"
        align="center"
        className={styles.errorBoundaryMessage}
      >
        Sorry. It looks like something unexpected happened. Please{' '}
        <Link as="button" onClick={openBrainFishWidget}>
          click here
        </Link>{' '}
        to report this to our team so we can get this fixed up.
      </Paragraph>
    </div>
  )
}

export default FittedFallbackComponent
